import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker, Form } from 'antd';
import { getIn } from 'formik';

const DatePickerInput = props => {
  const { field, form, label } = props;

  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const hasError = error !== undefined && touched;
  const isValid = !error && !!touched;

  const { name, value } = field;

  return (
    <Form.Item
      validateStatus={hasError ? 'error' : undefined}
      hasFeedback={isValid}
      label={label}
      help={(hasError && <li>{error}</li>) || (isValid && '')}
    >
      <DatePicker
        value={value}
        name={name}
        id={name}
        placeholder={label}
        onChange={val => {
          form.setFieldValue(name, val);
        }}
      />
    </Form.Item>
  );
};
DatePickerInput.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  label: PropTypes.string
};
export default DatePickerInput;
